module.exports = __webpack_public_path__ + "img/plh2.41883d18.png";